export function rulesUrl(product = 'waybetter') {
  if (product === 'waybetter') return '/rules';
  return `/${product}/rules`;
}
